module.exports = __webpack_public_path__ + "static/media/All_Accounts_video.36a71394.mp4";